import React from 'react';
import {
  string,
  bool,
  func,
} from 'prop-types';
import { TouchableWithoutFeedback, View } from 'react-native-web';
import { HeaderText } from '../../ui/HeaderText';
import BodyText from '../../ui/BodyText';
import Button from '../../ui/Button';
import Address from './Address';
import { googleMapURL } from '../../../modules/maps/location';
import './SidebarLocation.module.scss';
import { clickable } from '../../../styles';

export const propTypes = {
  name: string,
  city: string,
  state: string,
  zipcode: string,
  address1: string,
  address2: string,
  mobile_business: bool,
  public_phone_number: string,
  isEditMode: bool,
  onEdit: func,
  onAddressPress: func.isRequired,
};

const Text = props => (
  <BodyText appearance="small" weight="thin" {...props} />
);

const Location = props => {
  const {
    name,
    address1,
    address2,
    city,
    state,
    zipcode: zipCode,
    mobile_business: mobileBusiness,
    public_phone_number: publicPhoneNumber,
    isEditMode,
    onEdit,
    onAddressPress,
  } = props;
  const hasAddress = !!zipCode;

  return hasAddress ? (
    <View styleName="addr">
      <HeaderText level="4" styleName="header">{name}</HeaderText>
      <View
        itemprop="address"
        itemtype="http://schema.org/PostalAddress"
      >
        {/**
          TouchableWithoutFeedback seems to be very specific about what immediate
          child it will accept and still present as an `A` tag on the web.
          If the first child of <TouchableWithoutFeedback is not a <View> or <Text>
          it will not render.
         */}
        <TouchableWithoutFeedback
          accessible
          accessibilityRole="link"
          onPress={onAddressPress}
        >
          <View
            target="_blank"
            href={googleMapURL(props)}
            style={clickable}
          >
            <Address
              mobileBusiness={mobileBusiness}
              address1={address1}
              address2={address2}
              zipCode={zipCode}
              city={city}
              state={state}
            />
          </View>
        </TouchableWithoutFeedback>
        {publicPhoneNumber ? (
          <Text styleName="phone-number">
            {publicPhoneNumber}
          </Text>
        ) : null}
      </View>
      {isEditMode && typeof onEdit === 'function' ? (
        <Button
          onClick={onEdit}
          appearance="text-primary"
          size="small"
          testID="editBusinessInfoLink"
        >
          Edit Business Info
        </Button>
      ) : null}
    </View>
  ) : null;
};

Location.propTypes = propTypes;
Location.defaultProps = {
  name: undefined,
  city: undefined,
  state: undefined,
  zipcode: undefined,
  address1: undefined,
  address2: undefined,
  mobile_business: false,
  public_phone_number: undefined,
  isEditMode: false,
  onEdit: undefined,
};

export default Location;
